export const formatCount = (value: number | null): string => {
  if (value === null) return '—';
  return `${value} шт`;
};
